module.exports = __webpack_public_path__ + "img/icon_duoduo_code.9bca6aa0.png";